import React, {createContext, useContext, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import ErrorModal from "../../views/user/reports/components/ErrorModal";

// Create a Context
const FetchContext = createContext();

export const FetchProvider = ({ children }) => {
    const navigate = useNavigate();

    // Custom fetch function
    const fetchWrapper = async (url, options = {}) => {
        try {
            const response = await fetch(url, options);
            // Handle 401 & 403
            if (response.status === 401 || response.status === 403) {
                navigate('/auth/sign-in'); // Redirect to login
                return;
            }

            // If the response is not OK, extract the error body
            if (!response.ok) {
                const errorBody = await response.json().catch(() => null); // Safely parse JSON
                return Promise.reject({ status: response.status, body: errorBody });
            }
            return response;
        } catch (error) {
            throw error;
        }
    };

    return (
        <FetchContext.Provider value={fetchWrapper}>
            {children}
        </FetchContext.Provider>
    );
};

// Custom hook to use the fetchWrapper
export const useFetch = () => {
    return useContext(FetchContext);
};
